export const SCHEMA_DEV = 'acmeacademico'

const URL_KAKA_AWS_FUNCTION = 'https://5hau2sd37e.execute-api.us-east-1.amazonaws.com/production/hello'
const URL_NERIT_GC_FUNCTION = 'https://us-central1-nerit-mercado.cloudfunctions.net/sendIpagPayment'
const localhost = 'localhost'

const config = {
    devConfig: {
        host: localhost,
        nm_api: {
            baseUrl: 'http://' + localhost + ':3001/admin/',
            baseUrlOld: 'http://' + localhost + ':8080/app/restapi/'
        },
        aws: {
            bucketName: 'dev-nrt-mercado-bucket',
            region: 'us-east-1',
            credentials: {
                accessKeyId: 'AKIAXN6SAU54L6V2GDDM',
                secretAccessKey: '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',
            }
        },
        ipagEndpoint: 'https://sandbox.ipag.com.br',
        // ipagCloudFunctionEndpoint: 'http://localhost:4000/hello'
        ipagCloudFunctionEndpoint: URL_NERIT_GC_FUNCTION
    },


    tstConfig: {
        host: 'homologacao-nerit.firebaseapp.com',
        nm_api: {
            baseUrl: 'https://mercadoapi.nerit.com.br/admin/',
            baseUrlOld: 'https://acmeacademico.marta.nerit.com.br/app/restapi/'
        },
        aws: {
            bucketName: 'dev-nrt-mercado-bucket',
            region: 'us-east-1',
            credentials: {
                accessKeyId: 'AKIAXN6SAU54L6V2GDDM',
                secretAccessKey: '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',
            }
        },
        ipagEndpoint: 'https://sandbox.ipag.com.br',
        ipagCloudFunctionEndpoint: URL_NERIT_GC_FUNCTION
    },


    prodConfig: {
        host: 'minhacentral.trausedu.com.br',
        nm_api: {
            baseUrl: 'https://minhacentralapi.trausedu.com.br/admin/',
            baseUrlOld: 'https://integracao.trausedu.com.br/app/restapi/'
        },
        aws: {
            bucketName: 'neriteduca',
            region: 'us-east-1',
            credentials: {
                accessKeyId: 'AKIAXN6SAU54L6V2GDDM',
                secretAccessKey: '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',
            }
        },
        ipagEndpoint: 'https://www.librepag.com.br',
        ipagCloudFunctionEndpoint: URL_NERIT_GC_FUNCTION
    }
}


export const isDev = process.env.REACT_APP_STAGE === 'dev'

export const AppConfig = (function () {
    switch (process.env.REACT_APP_STAGE) {
        case 'dev':
            return config.devConfig

        case 'production':
            return config.prodConfig

        default:
            return config.tstConfig
    }
}())



// WEBPACK FOOTER //
// ./src/config/config.js